import type { IconProps } from "./icon-types";

/**
 * 달(moon). Dark 테마 표시/토글 등에서 사용.
 *
 * sigmakit-gui는 `react-icons/md`의 `MdOutlineDarkMode`를 쓰지만, c6 아이콘 세트 톤·크기 통일을 위해
 * 동일 의미의 `react-icons/lu` `LuMoon`(Lucide `moon`)을 인라인으로 재현 —
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘). 24 그리드 / stroke 기반.
 */
export const MoonIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
  </svg>
);
